import React, { memo } from "react";
import ZIcon from "@atoms/ZIcon";
import ZTypography from "@atoms/ZTypography";
import { EColors } from "@atoms/ZColors/interface";
import { IResourceGridFileProps } from "./interface";
import {
	getIconFromMimeType,
	getTwoToneIconFromMimeType
} from "@/Contracts/Utils";
import "./index.less";
import ZModal from "@atoms/ZModal";
import { EIcons } from "@atoms/ZIcon/interface";
import { ZImage } from "@atoms";
import ZMenu from "../ZMenu";
import ZDropdown from "../ZDropdown";
import { getYoutubeID } from "@/Utils";
import {
	ROOT_RESOURCE_ID,
	VendorResourceSharingType
} from "@/Contracts/Vendor/Resources";
import {
	stopSharingResourceConfirmModal,
	deleteResourceConfirmModal
} from "@/Utils/index";
import { isVendorApp } from "@/Utils";

const { ZText } = ZTypography;

const ZResourceGridFile: React.FC<IResourceGridFileProps> = ({
	name,
	mimeType,
	onDelete,
	onDoubleClick,
	onClick,
	thumbnail,
	isOnSalesEnablement = false,
	youtubeUrl = null,
	id,
	onShareResource,
	stopSharingResource,
	resource,
	handleManageAccess,
	recentlyAdded
}) => {
	const thumbnailURL = youtubeUrl
		? `http://img.youtube.com/vi/${getYoutubeID(youtubeUrl)}/hqdefault.jpg`
		: thumbnail;
	const menu = (
		<ZMenu>
			{/* <ZMenu.Item key="activity">Activity</ZMenu.Item> */}
			{resource &&
				(onShareResource &&
				resource?.sharing_details.sharing_type ===
					VendorResourceSharingType.PRIVATE ? (
					<ZMenu.Item
						key="Share"
						onClick={e => {
							e.domEvent.stopPropagation();
							onShareResource(resource);
						}}
					>
						Share
					</ZMenu.Item>
				) : (
					<ZMenu.Item
						key="Manage Access"
						onClick={e => {
							e.domEvent.stopPropagation();
							handleManageAccess?.(resource);
						}}
					>
						Manage Access
					</ZMenu.Item>
				))}
			{resource &&
				stopSharingResource &&
				resource.parent_dir_id === ROOT_RESOURCE_ID &&
				resource.sharing_details.sharing_type !==
					VendorResourceSharingType.PRIVATE && (
					<ZMenu.Item
						key="Stop Sharing"
						onClick={e => {
							e.domEvent.stopPropagation();
							stopSharingResourceConfirmModal(
								resource,
								stopSharingResource
							);
						}}
					>
						Stop Sharing
					</ZMenu.Item>
				)}
			<ZMenu.Item
				key="delete"
				danger
				onClick={e => {
					e.domEvent.stopPropagation();
					resource && onShareResource
						? deleteResourceConfirmModal(resource, onDelete)
						: ZModal.deleteConfirm({
								title: `Do you want to delete this file?`,
								onOk: onDelete
						  });
				}}
			>
				Delete
			</ZMenu.Item>
		</ZMenu>
	);
	return (
		<div>
			<div
				className={`z-resource-grid-file flex flex-col ${
					recentlyAdded ? "recently-added" : ""
				}`}
				onDoubleClick={onDoubleClick}
				onClick={onClick}
				title={name}
				id={id}
			>
				<div className="file-thumbnail flex items-center justify-center">
					{!!thumbnailURL ? (
						<ZImage
							className="rounded-lg"
							src={thumbnailURL}
							alt={name}
							preview={false}
						/>
					) : (
						<ZIcon
							isTwoToneIcon
							name={getTwoToneIconFromMimeType(mimeType)}
							size="xxl"
						/>
					)}
				</div>
				<div
					className={`flex ${
						isVendorApp() ? "justify-between" : ""
					} items-center p-4`}
				>
					<div className="z-resource-grid-file-description-wrap">
						<ZIcon
							className={`file-mime-icon`}
							name={getIconFromMimeType(mimeType)}
							size="md"
							colorVariant={8}
							color={EColors.GRAY}
						/>
						<ZText className="truncate ml-2 z-resource-grid-file-description">
							{name}
						</ZText>
					</div>
					{!isOnSalesEnablement && (
						<ZDropdown
							overlay={menu}
							className="float-right"
							placement="bottomRight"
						>
							<ZIcon
								onClick={e => e.stopPropagation()}
								colorVariant={7}
								name={EIcons.MOREVERTICAL}
								fill
								className="m-0 flex-shrink-0"
								size="md"
							/>
						</ZDropdown>
					)}
				</div>
			</div>
		</div>
	);
};

export default memo(ZResourceGridFile);
